import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable()
export class RetiroService {

  // Observable refresh list data categorias
  flagRefresh = new BehaviorSubject<any>(null);
  observableData$ = this.flagRefresh.asObservable();

  constructor(private http: HttpClient) { }

  // actualizamos flag
  nextData(flag: boolean) {
    this.flagRefresh.next(flag);
  }

  obtenerRetirosPorObraYFechas(id: number, fechaDesde:any, fechaHasta: string) {
    return this.http.get<any>(`${environment.api}/retiro/obra/${id}/fecha/${fechaDesde}/${fechaHasta}`);
  }

  obtenerBase64(id: number) {
    return this.http.get<any>(`${environment.api}/retiro/${id}/base64`);
  }

  obtenerCantidadRetirosPorObra(desde: any, hasta: any, obraId: number) {
    return this.http.get<any>(`${environment.api}/retiro/cantidad/desde/${desde}/hasta/${hasta}/obra/${obraId}`);
  }

  obtenerSumaM3(desde: any, hasta: any, obraId: number) {
    return this.http.get<any>(`${environment.api}/retiro/m3/desde/${desde}/hasta/${hasta}/obra/${obraId}`);
  }

  obtenerPesoPorObra(desde: any, hasta: any, obraId: number) {
    return this.http.get<any>(`${environment.api}/retiro/peso/desde/${desde}/hasta/${hasta}/obra/${obraId}`);
  }
  
  obtenerCantidadRetiros(anio: string, mes: string) {
    return this.http.get<any>(`${environment.api}/retiro/mes/${mes}/anio/${anio}`);
  }

   obtenerRetirosPorCiudadYFecha(id: number, fecha:any) {
     return this.http.get<any>(`${environment.api}/retiro/ciudad/${id}/fecha/${fecha}`);
   }


  obtenerRetirosPorUsuarioYFecha(id: number, fechaDesde:any, fechaHasta: string) {
    return this.http.get<any>(`${environment.api}/retiro/usuario/${id}/fecha/${fechaDesde}/${fechaHasta}`);
  }

  obtenerRetirosPorUsuarioYFechasGraficos(id: number, desde: any, hasta: any) {
    return this.http.get<any>(`${environment.api}/retiro/usuario/${id}/fecha/${desde}/${hasta}/graficos`);
  }

  obtenerRetirosConLimite(take: number) {
    return this.http.get<any>(`${environment.api}/retiro/take/${take}`);
  }

  obtenerRetirosConLimiteYUsuario(take: number, id: number) {
    return this.http.get<any>(`${environment.api}/retiro/usuario/${id}/take/${take}`);
  }


  crearRetiro(form: any) {
    return this.http.post(`${environment.api}/retiro`, form);
  }

  actualizarRetiro(form: any, retiroId: number) {
    return this.http.patch(`${environment.api}/retiro/${retiroId}`, form);
  }

  asignarFactura(form: any) {
    return this.http.post(`${environment.api}/retiro/asignar-facturas`, form);
  }

  eliminarRetiro(retiroId: number) {
    return this.http.delete(`${environment.api}/retiro/${retiroId}`);
  }

}
